import Vue from 'vue'
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
    cart: [],
    stock: [],
    user: false,
    locale: 'nl',
    customer: null,
    canSubmit: false
};

const mutations = {
    setStock(state, stock){
       this.state.stock = stock;
    },
    setCart(state, cart) {
        this.state.cart = cart;
    },
    setUser() {
        if (window.appUser !== 'undefined') {
            this.state.user = window.appUser;
        }
    },
    setLocale() {
        const languages = ['en', 'de'];
        let pathArray = window.location.pathname.split('/');
        if (languages.indexOf(pathArray[1]) !== -1) {
            this.state.locale = pathArray[1];
        }
    },
    setCustomer(state, customer) {
        this.state.customer = customer;
    },
};

export const store = new Vuex.Store({
    state,
    mutations
});

